import { Stack as StackMui } from "@mui/material";

export default function Stack({
  id,
  name,
  className,
  component,
  direction = "column",
  divider,
  spacing = 0,
  sx,
  useFlexGap = false,
  children,
  ...rest
}) {
  return (
    <StackMui
      id={id}
      name={name}
      className={className}
      component={component}
      direction={direction}
      divider={divider}
      spacing={spacing}
      sx={sx}
      useFlexGap={useFlexGap}
      {...rest}
    >
      {children}
    </StackMui>
  );
}
